import * as helpers from '../../js/helpers';
import Dropdown from '../../js/components/dropdown';

export default class Agreement {
    constructor(selector = '.js-agreement', options = {}) {
        this.selector = selector;

        this.buttonAdd = null;
        this.inputId = null;
        this.labels = null;
        this.lists = null;
        this.hiddenInput = null;
        this.data = null;

        this.$createAgreement = this.createAgreement.bind(this);

        this.init();
    }

    createSelect(id, list, selected) {
        const select = document.createElement('select');
        select.setAttribute('name', `select${id}`);
        select.setAttribute('id', `select${id}`);
        this.createOption(select, null, this.labels.selectFirstOption);

        // eslint-disable-next-line guard-for-in
        for (const itemId in list) {
            this.createOption(select, itemId, list, selected);
        }

        const labels = [...this.selector.querySelectorAll('label')];
        labels.forEach((label) => {
            if (label.getAttribute('for') === `select${id}`) {
                label.insertAdjacentElement('afterEnd', select);
            }
        });
    }

    createOption(select, id, text, selected) {
        const option = document.createElement('option');

        option.innerHTML = typeof text === 'string' ? text : text[id];

        if (id) {
            option.setAttribute('value', id);
        }

        if (id && selected && id.toString() === selected.toString()) {
            option.setAttribute('selected', 'selected');
        }

        select.appendChild(option);
    }

    createAgreement(eventItem, item) {
        const title = item ? item.title : this.labels.emptyTitle;
        const tagSelectedId = item ? item.tag : null;
        const categorySelectedId = item ? item.category : null;
        const btnRemove = '<button type="button" class="js-agreement-remove"><span class="ghost">Remove agreement</span></button>';
        const id1 = helpers.getUniqId();
        const id2 = helpers.getUniqId();
        const id3 = helpers.getUniqId();

        const newCard = `
                <dl class="agreement-item">
                    <dt><button type="button" class="agreement-item__toggle">${title}</button>${btnRemove}</dt>
                    <dd class="agreement-item__block" data-response="Réponse :">
                    <div class="flex-row">
                        <div class="col-xs-12">
                            <div class="form__field-wrapper">
                                <label for="select${id1}">${this.labels.labelTags}</label>
                            </div>
                        </div>
                        <div class="col-xs-12">
                            <div class="form__field-wrapper">
                                <label for="input${id2}">${this.labels.labelInput}</label>
                                <input type="text" name="input${id2}" id="input${id2}" value="${item ? item.title : ''}"
                                placeholder="${this.labels.inputPlaceholder}">
                            </div>
                        </div>
                        <div class="col-xs-12">
                            <div class="form__field-wrapper">
                                <label for="select${id3}">${this.labels.labelCategories}</label>
                            </div>
                        </div>
                    </div>
                    </dd>
                </dl>`;

        this.selector.insertAdjacentHTML('beforeend', newCard);
        this.createSelect(id1, this.lists.tags, tagSelectedId);
        this.createSelect(id3, this.lists.categories, categorySelectedId);

        this.initDropdown();
        this.removeAgreement();
    }

    initDropdown() {
        const agreement = new Dropdown('.agreement-item', {
            wrapperClass: 'agreement-item',
            dropdownClass: 'agreement-item__block',
            btnClass: 'agreement-item__toggle',
            closeOnOutsideClick: false,
            openTypeSlide: true,
            isWrapContent: true,
        });
    }

    removeAgreement() {
        const buttonsRemove = [...this.selector.querySelectorAll('.js-agreement-remove')];
        if (buttonsRemove && buttonsRemove.length) {
            buttonsRemove.forEach((btn) => {
                btn.addEventListener('click', () => {
                    const item = btn.parentElement.parentElement;
                    item.parentNode.removeChild(item);
                });
            });
        }
    }

    init() {
        const agreements = [...document.querySelectorAll('.js-agreement')];

        agreements.forEach((agreement) => {
            this.selector = agreement;
            this.hiddenInput = document.querySelector('#agreement');

            const state = JSON.parse(this.selector.getAttribute('data-state'));
            this.inputId = state.inputId;
            this.labels = state.labels;
            this.lists = state.lists;

            const items = this.hiddenInput.getAttribute('value');
            this.item = [...JSON.parse(items)];
            if (this.item && this.item.length > 0) {
                this.item.forEach((item) => {
                    this.createAgreement(null, item);
                });
            }
            this.data = this.item;

            const btnAdd = document.createElement('button');
            btnAdd.setAttribute('type', 'button');
            helpers.addClass(btnAdd, 'btn js-agreement-add');
            btnAdd.innerHTML = this.labels.addAgreement;
            this.buttonAdd = btnAdd;
            this.buttonAdd.addEventListener('click', this.$createAgreement);
            this.selector.insertAdjacentElement('afterbegin', this.buttonAdd);
        });
    }
}
